import { z } from "zod";
export const orderStatusSchema = z.enum([
    "ordered",
    "partially_received",
    "received",
]);
export const orderSummarySchema = z.object({
    id: z.string().uuid(),
    supplierId: z.string().uuid(),
    supplierName: z.string(),
    createdById: z.string(),
    createdByFullname: z.string(),
    orderedAt: z.string(),
    status: orderStatusSchema,
    orderedQuantity: z.number().int().nonnegative(),
    receivedQuantity: z.number().int().nonnegative(),
    paidTotalCents: z.number().int().nonnegative(),
    invoicedTotalCents: z.number().int().nonnegative(),
});
export const orderLineSchema = z.object({
    id: z.string().uuid(),
    brand: z.string(),
    commercialName: z.string(),
    manufacturerReference: z.string(),
    supplierReference: z.string(),
    catalogUnitPriceCents: z.number().int().nonnegative(),
    orderedQuantity: z.number().int().positive(),
    receivedQuantity: z.number().int().nonnegative(),
    paidTotalCents: z.number().int().nonnegative(),
    invoicedTotalCents: z.number().int().nonnegative(),
    isInvoiced: z.boolean().optional(),
});
export const ordersPageSchema = z.object({
    orders: z.array(orderSummarySchema),
    nextOffset: z.number().int().nonnegative().nullable(),
});
const receiptLineSchema = z.object({
    orderLineId: z.string().uuid(),
    receivedQuantity: z.number().int().positive().max(2147483647),
    paidUnitPriceCents: z.number().int().nonnegative().max(2147483647),
});
export const receiptInputSchema = z.object({
    lines: z
        .array(receiptLineSchema)
        .min(1)
        .refine((lines) => new Set(lines.map((line) => line.orderLineId)).size === lines.length, { message: "Un article ne peut apparaître qu’une fois par réception." }),
});
export const orderDetailSchema = z.object({
    order: orderSummarySchema,
    lines: z.array(orderLineSchema),
    receipts: z.array(z.object({
        id: z.string().uuid(),
        receivedByFullname: z.string(),
        receivedAt: z.string(),
        lines: z.array(receiptLineSchema),
    })),
});
export function priceToCents(value) {
    if (typeof value !== "string")
        return null;
    const normalized = value.trim().replace(",", ".");
    if (!/^\d+(\.\d{1,2})?$/.test(normalized))
        return null;
    const [euros, decimals = ""] = normalized.split(".");
    const cents = Number(euros) * 100 + Number(`${decimals}00`.slice(0, 2));
    return Number.isSafeInteger(cents) && cents <= 2147483647 ? cents : null;
}
//# sourceMappingURL=receipts.js.map